module.exports = __webpack_public_path__ + "fd5a608a/img/66000000-0.8b55c107.png";